import { ref } from 'vue'
import { wechatLogin } from '@/api/auth'
import type { UserInfo } from '@/types'
import {TOKEN_KEY, USER_KEY} from '@/utils/constants.ts'
// 响应式登录状态
export const isLoggedIn = ref(!!localStorage.getItem(TOKEN_KEY))
export const currentUser = ref<UserInfo | null>(getSavedUser())

function getSavedUser(): UserInfo | null {
  try {
    const raw = localStorage.getItem(USER_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

/**
 * 登录：存储 token 和用户信息
 */
export function login(token: string, userInfo?: UserInfo): void {
  localStorage.setItem(TOKEN_KEY, token)

  if (userInfo) {
    localStorage.setItem(USER_KEY, JSON.stringify(userInfo))
    currentUser.value = userInfo
  }

  isLoggedIn.value = true
}

/**
 * 退出登录：清除存储
 */
export function logout() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
  localStorage.removeItem('wx_auth_state')

  isLoggedIn.value = false
  currentUser.value = null
}

/**
 * 获取 token
 */
export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

/**
 * 获取用户信息
 */
export function getUserInfo(): UserInfo | null {
  return currentUser.value
}

/**
 * 微信网页授权 —— 用 code 换 token
 * 向后端发送 code，后端返回登录 token 和用户信息
 */
export async function loginByWechatCode(code: string): Promise<{
  token: string
  userInfo: UserInfo
}> {
  let token = ''
  let userInfo = {}
  await wechatLogin(code).then((res:any) => {
    if (res) {
      token = res.token
      userInfo = res.userInfo
    }
  })
  console.log(token)
  console.log(userInfo)
  // 存储登录态
  login(token, userInfo)

  return { token, userInfo }
}

export type { UserInfo }
